import { Link } from 'react-router-dom';
import { categories } from '@/mocks/news';

export default function CategoryGrid({ counts }: { counts: Record<string, number> }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
      {categories.map((c) => (
        <Link
          key={c.id}
          to={`/category/${c.id}`}
          className="group flex flex-col items-center justify-center gap-2 rounded-lg border border-background-200 bg-background-50 px-3 py-5 text-center transition-colors hover:border-primary-300 hover:bg-primary-50"
        >
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-600 group-hover:text-background-50">
            <i className={`${c.icon} text-2xl`}></i>
          </span>
          <span className="font-heading text-sm font-bold text-foreground-900">
            {c.name}
          </span>
          <span className="text-xs text-foreground-500">{counts[c.id] ?? 0} 篇</span>
        </Link>
      ))}
    </div>
  );
}